import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { Employee } from '../../../types/Employee';
import { Dictionary } from 'lodash';

export interface IUserProfilePayload {
  employee: Partial<Employee>,
  password?: {
    current_password: string,
    new_password: string,
    confirmed_password: string,
  },
  notifications?: Dictionary<string>,
}

export const updateUserProfile = async (formData: IUserProfilePayload) => {
  await CustomAxios.put('user-profile', formData);
};

export function useUpdateUserProfile() {
  return useMutation({
    mutationFn: (formData: IUserProfilePayload) => updateUserProfile(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmployees, 'current'] });
      // TODO also invlidate notifications once we have support for that
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const employee: Employee = err.response.data as Employee;
        queryClient.setQueryData([queryKeys.allEmployees, 'current'], employee);
      }
    },
  });
}
